export enum SendType {
    SMS = 'SMS',
    Email = 'Email',
    SystemNote = 'SystemNote',
    ActivityNote = 'ActivityNote',
    EmailMarketing = 'EmailMarketing',
    SmsMarketing = 'SmsMarketing',
    RequestReview = 'RequestReview',
}

export enum StatusMessage {
    UnRead = 'UnRead',
    Read = 'Read'
}